export default __webpack_public_path__ + "static/media/placeholder.ea8b5743.svg";